import { useModalStore } from '@features/modal'
import DeleteCardModal from '@features/payment/ui/delete-card-modal/DeleteCardModal'

export default function useClearCartModal () {
  const { openModal, closeModal } = useModalStore()

  return {
    openDeleteCardModal: () => openModal('deleteCard', <DeleteCardModal />),
    closeDeleteModal: () => closeModal('deleteCard'),
  }
}
